<template>
  <div class="equipmentDetailPage">
    <div class="title">
      <p>
        <span @click="router.go(-1)">峰谷管理</span>
        <span> / </span>
        <span>查看设备</span>
      </p>
      <p>
        <el-icon @click="router.go(-1)">
          <Back/>
        </el-icon>
        <span>查看设备</span>
      </p>
    </div>
    <div class="content">
      <!--左侧内容-->
      <div class="leftBox">
        <div class="searchBox">
          <el-input v-model="searchVal" class="input-with-select" clearable placeholder="请输入">
            <template #append>
              <el-button :icon="Search" @click="searchClick(customerList,searchVal)"/>
            </template>
          </el-input>
        </div>
        <div class="treeBox">
          <!--树形结构懒加载-->
          <el-tree ref="treeRef" :current-node-key="currentNodeKey" :data="customerList"
                   :default-expanded-keys="defaultExpandKeys"
                   :expand-on-click-node="false" :load="treeList"
                   :props="{label: 'name',children: 'subList',isLeaf:'noExistSub'}"
                   lazy node-key="id"
                   @node-click="handleNodeClick">
          </el-tree>
        </div>
      </div>
      <!--右侧内容-->
      <div class="rightBox">

        <div class="tab">
          <el-tabs v-model="showFlag" class="demo-tabs" style="width: calc(100% - 150px)"
                   @tab-click="tabClick">
            <el-tab-pane label="网关连接设备" name="6"></el-tab-pane>
            <!--            <el-tab-pane label="直连设备" name="7"></el-tab-pane>-->
            <el-tab-pane label="直接连接设备" name="8"></el-tab-pane>
          </el-tabs>
          <div style="display:flex;align-items: start">
            <img v-if="custerObj.monitorList&&custerObj.monitorList.length>0" alt=""
                 src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/videoIcon.png"
                 style="width: 24px;height: 24px;cursor: pointer;margin-left: 12px;margin-top: 7px"
                 @click="lookVideoDetail">
          </div>
        </div>

        <div v-if="showFlag==6||showFlag==7"
             style="height: calc(100% - 70px);overflow: auto">
          <ProjectDevice :custerObj="custerObj" :mainId="router.currentRoute.value.query.id"
                         :mainType="router.currentRoute.value.query.type"
                         :tabindex="showFlag"/>
        </div>
        <div v-if="showFlag==8" style="height: calc(100% - 70px);overflow: auto">
          <MqttDevice :custerObj="custerObj" :mainId="router.currentRoute.value.query.id"
                      :mainType="router.currentRoute.value.query.type"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import {ref} from "vue"
import {getTreePrefix} from "@/api/modules/dataSearch";
import qs from "qs";
import {ElMessage} from "element-plus";
import {getSubTreeWithRateApi, getTopTreeWithRateApi} from "@/api/modules/rate";
import router from "@/router";
import {Back, Search} from '@element-plus/icons-vue'
import ProjectDevice from './projectDevice'
import MqttDevice from './mqttDevice'


// 项目树--------------------------------------------------------------
let custerObj = ref({}) //当前项目信息
let searchVal = ref() //树级列表字段
let currentNodeKey = ref() //默认选中树级列表第一级
let defaultExpandKeys = ref() //默认选中树级列表第一级
let treeRef = ref()
let customerList = ref([])
//树级列表搜索
const searchClick = function (data, name) {
  treeRef.value.filter(name)
}
// 项目树懒加载-------------------
const treeList = async function (node, resolve) {
  if (node.level === 0) {
    await getTopTreeWithRateApi(qs.stringify({
      type: router.currentRoute.value.query.type,
      id: router.currentRoute.value.query.id,
    })).then(res => {
      if (res.data.code === 0) {
        handleNodeClick(res.data.result)
        defaultExpandKeys.value = [res.data.result.id]
        currentNodeKey.value = res.data.result.id
        return resolve([res.data.result])
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message
        })
      }
    }).catch(err => {
      console.log(err);
    })
  } else if (node.level === 1) {
    await getTopTreeWithRateApi(qs.stringify({
      type: router.currentRoute.value.query.type,
      id: router.currentRoute.value.query.id,
    })).then(res => {
      if (res.data.code === 0) {
        return resolve(res.data.result.subList)
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message
        })
      }
    }).catch(err => {
      console.log(err);
    })
  } else {
    await getSubTreeWithRateApi(qs.stringify({
      projectId: node.data.id,
      type: router.currentRoute.value.query.type,
      id: router.currentRoute.value.query.id,
    })).then(res => {
      if (res.data.code === 0) {
        return resolve(res.data.result)
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }

}
// 项目树点击
const handleNodeClick = function (e) {
  custerObj.value = e
  currentNodeKey.value = e.id
  defaultExpandKeys.value = []
  defaultExpandKeys.value.push(e.parentId)
  getEquipmentSelectFun()
}
// 根据项目获取设备选项
let equipmentSelectList = ref([])
const getEquipmentSelectFun = function () {
  getTreePrefix(qs.stringify({
    id: custerObj.value.idStr,
  })).then(res => {
    if (res.data.code === 0) {
      equipmentSelectList.value = res.data.result
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })
}


// 点击是否展示下级的tab
let showFlag = ref('6')
const tabClick = function (e) {
  showFlag.value = e.paneName
}


</script>

<style lang="less">
.equipmentDetailPage {
  width: 100%;
  height: 100%;
  //标题
  .title {
    width: calc(100% - 36px);
    height: 84px;
    padding-left: 36px;
    line-height: 48px;
    //background-color: #EDF0F6;

    p:nth-child(1) {
      color: rgba(0, 0, 0, .45);

      span:nth-child(1):hover, span:nth-child(3):hover {
        color: #165DFF;
        cursor: pointer;
      }

      span:nth-child(5) {
        color: rgba(0, 0, 0, .85);
      }
    }

    p:nth-child(2) {
      height: 24px;
      line-height: 24px;
      font-size: 16px;
      font-weight: 500;

      .el-icon {
        font-size: 18px;
        font-weight: bold;
        transform: translateY(3px);
        cursor: pointer;
      }

      .el-icon:hover {
        color: #165DFF;
      }
    }
  }

  //内容
  .content {
    width: calc(100% - 56px);
    height: calc(100% - 108px);
    padding: 0 28px 20px;
    overflow: auto;
    display: flex;

    .leftBox {
      height: calc(100% - 20px);
      //flex: 2;
      //width: 265px;
      background-color: #fff;
      padding-top: 20px;
      margin-right: 16px;
      border-radius: 6px;
      box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.09);
      position: relative;

      .searchBox {
        padding: 0 20px;
        height: 40px;
      }

      .treeBox {
        margin: 0 20px;
        //width: calc(100% - 40px);
        height: calc(100% - 105px);
        overflow: auto;
        /*el-tree样式*/

        .el-tree-node__content {
          height: 40px;

          .opacityIcon {
            display: none;
          }

          .el-icon.opacityIcon {
            color: #999999;
            transform: translateY(5px);
            margin-left: 8px;
            font-weight: bold;
            font-size: 17px;
          }

          .addInput {
            border: 0;

            .el-input__wrapper.is-focus {
              box-shadow: 0 0 0 0;
            }
          }
        }

        //.el-tree-node__children {
        //  overflow: auto;
        //}

        .el-tree-node__content:hover {
          background-color: rgba(22, 93, 255, 0.10);

          .opacityIcon {
            display: inline-flex;
          }
        }

        .el-tree-node__content:has(.addInput) {
          /* 父元素样式 */
          background-color: #165DFF;
        }

        /*选中颜色*/

        .el-tree-node.is-current > .el-tree-node__content {
          background: rgba(22, 93, 255, 0.1);
          color: #165DFF;

          .el-icon {
            color: #165DFF;
          }

          .el-icon.opacityIcon {
            color: #999999;
          }
        }

        .el-tree {
          --el-tree-expand-icon-color: #000;
          color: #000;
        }

        .custom-tree-node {
          .localSymbol {
            display: inline-block;
            width: 32px;
            height: 16px;
            background: rgba(22, 93, 255, 0.1);
            border-radius: 2px;
            border: 1px solid #165DFF;
            font-size: 12px;
            color: #165DFF;
            text-align: center;
            line-height: 16px;
            margin-left: 5px;
          }
        }

      }

      .addBox {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 64px;

        .el-button {
          width: 80%;
          border: 1px solid #165DFF;
          color: #165DFF;
          font-weight: 300;
        }
      }

      .listShow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        width: 38px;
      }

      .listShow2 {
        right: -10px;
      }
    }

    .rightBox {
      flex: 6;
      overflow: auto;
      //background-color: #fff;


      .tableBox, .curstCont {
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.09);
      }

      .headerDiv {
        height: 32px;
        position: relative;
        padding: 8px 24px 0px;
        font-size: 16px;
        vertical-align: middle;
        background-color: #fff;

        .userBox {
          display: inline-block;
          padding-left: 20px;
          color: rgba(3, 10, 26, 0.65);
        }

        .viewBox {
          position: absolute;
          right: 170px;
          top: 16px;
        }

        .customizedBtn {
          border: 1px solid #165DFF;
          color: #165DFF;
          position: absolute;
          right: 160px;
          top: 8px;
        }

        .eidtButton {
          position: absolute;
          right: 30px;
          top: 8px;
        }
      }

      .el-carousel__indicators--horizontal {
        display: flex;
        justify-content: center;
      }

      .baseBox {
        padding: 0 24px 14px;
        height: 120px;
        display: flex;
        flex-wrap: wrap;
        vertical-align: baseline;
        color: #191919;
        background-color: #fff;
        margin-bottom: 20px;

        .imgBox {
          width: 120px;
          height: 120px;

          img {
            width: 100%;
            margin-top: 50%;
            transform: translateY(-50%);
          }

          .el-carousel__indicators {
            display: none;
          }

          .el-carousel__arrow {
            //background-color: transparent;
            //color: #f6f6f6;
            font-size: 20px;
            font-weight: 700;
          }

          .el-carousel__arrow--left {
            left: 0px;
          }

          .el-carousel__arrow--right {
            right: 0px;
          }
        }

        .baseBox1 {
          width: calc(100% - 140px);
          height: 120px;
          padding-top: 0;
          flex-wrap: wrap;
          margin-left: 20px;

          > p {
            font-size: 16px;
            height: 26px;
            line-height: 26px;
          }

          .baseBox {
            height: calc(100% - 36px);
            padding: 5px 0 15px;
            margin: 0;
            flex-wrap: wrap;
            align-items: center;

            .contItem {
              height: 30px;
              margin-right: 60px;
              display: flex;
              align-items: center;

              img {
                width: 24px;
                height: 24px;
              }
            }
          }
        }
      }

      .headBox {
        width: 100%;
        display: flex;
        background-color: #ffffff;
        //margin-bottom: 16px;


        .imgBox {
          width: 254px;
          height: 254px;

          .el-carousel__item {
            img {
              width: 100%;
            }
          }
        }

        .headRightBox {
          flex: 1;
          display: flex;
          flex-direction: column;
          margin-left: 10px;

          .topBox {
            display: flex;
            flex-direction: column;

            .topBoxHead {
              display: flex;
              justify-content: space-between;
              padding: 10px 5px;

              > p {
                font-size: 18px;
              }

              .exitClass {
                width: 80px;
                height: 32px;
                background: #165DFF;
                border-radius: 16px 0 0 16px;
                color: #FFFFFF;
                display: none;
              }
            }

            .baseBox {
              height: calc(100% - 36px);
              padding: 5px 0 15px;
              margin: 0;
              flex-wrap: wrap;
              align-items: center;
              display: flex;

              .contItem {
                height: 30px;
                margin-right: 20px;
                display: flex;
                align-items: center;

                img {
                  width: 24px;
                  height: 24px;
                }
              }
            }
          }

          .bottomBox {
            flex: 1;
            width: 100%;
            height: 100%;

            #allmap2 {
              width: 100%;
              height: 100%;
            }
          }
        }
      }

      .tableHeader {
        padding: 20px 24px 0;
        position: relative;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        background-color: #ffffff;
        border-top: 1px solid #ECEEF6;

        .seachBox {
          display: flex;
          padding: 0px 0 20px;

          .el-input {
            //width: 200px;
            margin-right: 10px;
          }
        }

        .btn {
          width: 191px;
          padding-bottom: 20px;
        }
      }

      .tableBox,
      .tab {
        padding: 0 16px;
        background-color: #ffffff;
      }

      .tab {
        padding-top: 12px;
        display: flex;
        justify-content: space-between;

        //.el-tabs {
        //  .el-tabs__nav-wrap::after {
        //    width: 0;
        //  }
        //
        //  .el-tabs__active-bar {
        //    height: 0;
        //  }
        //
        //  .el-tabs__nav.is-top {
        //    background-color: #F5F7FB;
        //    border-radius: 5px;
        //  }
        //
        //  .el-tabs__item {
        //    text-align: center;
        //    padding: 0 40px;
        //    border-radius: 5px;
        //  }
        //
        //  .is-active {
        //    background-color: #165DFF;
        //    color: #ffffff;
        //    border-radius: 5px;
        //  }
        //
        //  .el-tabs__header {
        //    margin-bottom: 12px;
        //  }
        //}
      }

      .tableBox {
        background-color: #ffffff;

        .operationUl {
          display: flex;

          .editClass {
            margin: 0 10px;
          }
        }
      }

      .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
        background: #fff !important;
      }

      .el-table {
        .el-table__body-header,
        .el-table__header,
        .el-table__body {
          th {
            background-color: #fafafa;
            font-weight: 500;
          }

          //th:nth-child(2)::before, th:nth-child(3)::before, th:nth-child(4)::before, th:nth-child(5)::before, th:nth-child(6)::before, th:nth-child(7)::before {
          //  content: '';
          //  width: 1px;
          //  height: 1.6em;
          //  position: absolute;
          //  left: 0;
          //  top: 50%;
          //  transform: translateY(-50%);
          //  background-color: rgba(0, 0, 0, 0.06);
          //}
        }

        .statusOnClass {
          display: flex;
          justify-content: space-around;
          align-items: center;
          width: 60px;
          height: 22px;
          background: #E8FFEA;
          border-radius: 3px;
          color: #00B42A;

          .dotOnClass {
            border-radius: 50%;
            width: 6px;
            height: 6px;
            background: #00B42A;
          }
        }

        .statusOutClass {
          display: flex;
          justify-content: space-around;
          align-items: center;
          width: 60px;
          height: 22px;
          background: #FFECE8;
          border-radius: 3px;
          color: #F53F3F;

          .dotOutClass {
            border-radius: 50%;
            width: 6px;
            height: 6px;
            background: #F53F3F;
          }
        }
      }

      //分页
      .footerBox {
        padding: 14px 24px 24px 0;
        display: flex;
        justify-content: flex-end;

        .el-pager li.is-active {
          border: 1px solid #165DFF;
          margin-right: 8px;
          font-size: 13px;
        }

        .el-pagination--small button,
        .el-pagination--small span:not([class*=suffix]) {
          font-size: 13px;
        }
      }

      //仪表盘
      .curstCont {
        background-color: #ffffff;

        .boxCont {
          border-bottom: 1px solid #efefef;
          padding: 10px 24px;
          display: flex;
          flex-wrap: wrap;

          .itemBox {
            background-color: #F5F7FB;
            position: relative;
            width: calc(19% - 20px);
            height: 80px;
            padding: 10px;
            margin-right: 1%;
            margin-bottom: 10px;

            .tit {
              color: #999999;
              font-size: 12px;
            }

            .val {
              color: #191919;
              font-size: 30px;
            }

            .close {
              position: absolute;
              right: 10px;
              top: 8px;
              cursor: pointer;
            }

            > img {
              position: absolute;
              bottom: 0;
              right: 0;
            }
          }
        }

        .chatCont {
          padding: 10px 24px;

          .projectName {
            font-size: 20px;
            text-align: center;
          }

          .itemCont {
            margin: 40px 0 40px;

            .close {
              text-align: right;
            }

            .chart {
              width: 100%;
              height: 400px;
            }
          }

          .chart {
            //div, canvas {
            //  width: 100% !important;
            //}
          }
        }
      }


    }
  }
}
</style>
